interface ItemHeadlineProps {
	children: any;
	style?: any;
}
export const ItemHeadline: React.FC<ItemHeadlineProps> = ({ children, style }) => (
	<th className='text-decoration-underline' style={style}>
		{children}
	</th>
);
